// Mock data for RabatHub discount app

export const featuredShops = [
  {
    id: 1,
    name: "Zalando",
    logo: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=200&h=200&fit=crop",
    discount: "20% rabat",
    code: "SPAR20",
    category: "Mode",
    rating: 4.8,
    totalCodes: 12
  },
  {
    id: 2,
    name: "Ellos",
    logo: "https://images.unsplash.com/photo-1445205170230-053b83016050?w=200&h=200&fit=crop",
    discount: "15% rabat",
    code: "ELLOS15",
    category: "Hjem & Have",
    rating: 4.6,
    totalCodes: 8
  },
  {
    id: 3,
    name: "HelloFresh",
    logo: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=200&h=200&fit=crop",
    discount: "40% rabat",
    code: "FRESH40",
    category: "Mad & Drikke",
    rating: 4.9,
    totalCodes: 15
  },
  {
    id: 4,
    name: "Sinful",
    logo: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=200&h=200&fit=crop",
    discount: "25% rabat",
    code: "SINFUL25",
    category: "Wellness",
    rating: 4.7,
    totalCodes: 10
  },
  {
    id: 5,
    name: "Hunkemöller",
    logo: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=200&h=200&fit=crop",
    discount: "30% rabat",
    code: "HUNKE30",
    category: "Mode",
    rating: 4.5,
    totalCodes: 9
  },
  {
    id: 6,
    name: "Interflora",
    logo: "https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=200&h=200&fit=crop",
    discount: "10% rabat",
    code: "BLOOM10",
    category: "Gaver",
    rating: 4.8,
    totalCodes: 6
  },
  {
    id: 7,
    name: "Pilgrim",
    logo: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=200&h=200&fit=crop",
    discount: "20% rabat",
    code: "PILGRIM20",
    category: "Smykker",
    rating: 4.6,
    totalCodes: 11
  },
  {
    id: 8,
    name: "Synoptik",
    logo: "https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=200&h=200&fit=crop",
    discount: "15% rabat",
    code: "SYN15",
    category: "Sundhed",
    rating: 4.7,
    totalCodes: 7
  },
  {
    id: 9,
    name: "Ideal of Sweden",
    logo: "https://images.unsplash.com/photo-1556656793-08538906a9f8?w=200&h=200&fit=crop",
    discount: "25% rabat",
    code: "IDEAL25",
    category: "Elektronik",
    rating: 4.9,
    totalCodes: 13
  },
  {
    id: 10,
    name: "Spartoo",
    logo: "https://images.unsplash.com/photo-1549298916-b41d501d3772?w=200&h=200&fit=crop",
    discount: "20% rabat",
    code: "SHOE20",
    category: "Sko",
    rating: 4.5,
    totalCodes: 10
  },
  {
    id: 11,
    name: "MuscleHouse",
    logo: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=200&h=200&fit=crop",
    discount: "15% rabat",
    code: "MUSCLE15",
    category: "Sport & Fitness",
    rating: 4.8,
    totalCodes: 14
  },
  {
    id: 12,
    name: "Pixum",
    logo: "https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=200&h=200&fit=crop",
    discount: "30% rabat",
    code: "PHOTO30",
    category: "Foto",
    rating: 4.6,
    totalCodes: 8
  }
];

export const categories = [
  { id: 'all', name: 'Alle', count: 150 },
  { id: 'mode', name: 'Mode', count: 45 },
  { id: 'elektronik', name: 'Elektronik', count: 32 },
  { id: 'hjem', name: 'Hjem & Have', count: 28 },
  { id: 'mad', name: 'Mad & Drikke', count: 20 },
  { id: 'sport', name: 'Sport & Fitness', count: 25 }
];

export const stats = [
  { label: 'Aktive Rabatkoder', value: '15.000+', icon: 'tag' },
  { label: 'Glade Brugere', value: '450.000+', icon: 'users' },
  { label: 'Gennemsnitlig Rating', value: '4.9/5', icon: 'star' },
  { label: 'Penge Spart', value: '125M kr', icon: 'piggyBank' }
];

export const testimonials = [
  {
    id: 1,
    name: "Mette Hansen",
    platform: "iPhone",
    rating: 5,
    text: "Utrolig let at bruge! RabatHub finder automatisk de bedste rabatkoder, så jeg aldrig går glip af en god deal. Har allerede sparet over 2000 kr!"
  },
  {
    id: 2,
    name: "Anders Nielsen",
    platform: "Chrome",
    rating: 5,
    text: "Simpelthen genial! Jeg handler meget online, og RabatHub har gjort det så nemt at spare penge. Kan varmt anbefales!"
  },
  {
    id: 3,
    name: "Line Petersen",
    platform: "Safari",
    rating: 5,
    text: "Super smart app! Den viser automatisk rabatkoder når jeg shopper, og jeg har aldrig savnet en discount siden jeg installerede den."
  },
  {
    id: 4,
    name: "Thomas Larsen",
    platform: "Chrome",
    rating: 5,
    text: "Det her er den bedste shopping tool jeg har prøvet. RabatHub finder rabatkoder jeg aldrig ville have fundet selv. 5 stjerner herfra!"
  },
  {
    id: 5,
    name: "Sophie Andersen",
    platform: "iPhone",
    rating: 5,
    text: "Elsker notifikationerne når der er nye rabatkoder til mine yndlingsbutikker. Har sparet en masse penge siden jeg startede med at bruge RabatHub!"
  },
  {
    id: 6,
    name: "Michael Jensen",
    platform: "Mac",
    rating: 5,
    text: "Fantastisk! Det er så nemt - installer den og glem alt om det. RabatHub klarer resten og finder automatisk de bedste tilbud."
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Installér RabatHub",
    description: "Download vores gratis browser extension eller mobil app. Det tager kun 30 sekunder.",
    icon: "download"
  },
  {
    step: 2,
    title: "Shop som normalt",
    description: "RabatHub aktiveres automatisk når du er ved kassen på over 10.000 online butikker.",
    icon: "shoppingCart"
  },
  {
    step: 3,
    title: "Spar automatisk",
    description: "Vi tester alle tilgængelige rabatkoder og anvender den bedste automatisk. Du sparer penge uden at løfte en finger!",
    icon: "sparkles"
  }
];

export const faqs = [
  {
    question: "Er RabatHub virkelig gratis?",
    answer: "Ja! RabatHub er 100% gratis at bruge. Vi får en lille provision fra butikkerne når du handler gennem vores links, men det koster dig aldrig noget ekstra."
  },
  {
    question: "Hvordan finder I alle rabatkoderne?",
    answer: "Vi samarbejder direkte med tusindvis af webshops og har et stort community af brugere der deler koder. Vores system opdaterer konstant og tester alle koder for at sikre de virker."
  },
  {
    question: "Hvilke butikker understøtter I?",
    answer: "Vi understøtter over 10.000 online butikker i Danmark og internationalt. Nye butikker tilføjes løbende baseret på brugeranmodninger."
  },
  {
    question: "Er mine data sikre?",
    answer: "Absolut! Vi tager din privatliv meget seriøst. Vi samler aldrig dine personlige eller betalingsoplysninger. Læs mere i vores privatlivspolitik."
  },
  {
    question: "Hvordan får jeg notifikationer om nye rabatter?",
    answer: "Når du installerer RabatHub, kan du vælge dine yndlingsbutikker. Du får derefter automatisk besked når der er nye rabatkoder eller særlige tilbud."
  }
];